export type FilesViewMode = 'grid' | 'list';

export type SortDir = 'ASC' | 'DESC';

export type AiFilesGetSortBy = 'Id' | 'DateCreate' | 'DateUpdate' | 'Status';

export enum AiFileStatus {
  Draft = 0, // Черновик
  Pending = 1, // Ожидает обработки
  Processing = 2, // В обработке
  Processed = 3, // Обработан успешно
  Error = 4, // Ошибка обработки
}

export type AiFileUpdateStatus = 'Draft' | 'Pending';

export type AiFileItem = {
  Id: number;
  DateCreate: number; // Unix, секунды
  DateUpdate: number; // Unix, секунды; 0 — не обновлялся
  Status: number; // AiFileStatus
  Key: string; // UUID в хранилище
  Name: string; // отображаемое имя, вводит клиент (напр. "Strategy 1")
  Comment: string; // комментарий/ошибка обработки, может быть ""
};

export type AiFilesGetResponse = {
  count: number;
  rows: AiFileItem[];
};

export type FilesLoadParams = {
  Status?: number;
  Limit?: number;
  Offset?: number;
  SortBy?: AiFilesGetSortBy;
  SortDir?: SortDir;
};

export type FilesState = {
  readyStatus: string;
  err: string | null;
  count: number;
  rows: AiFileItem[];
};
